// new-contract-component.ts - Versión template-driven (sin ReactiveFormsModule)
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WarrantySelectorDialogComponent } from 'src/app/dialogs/warranty-selector-dialog/warranty-selector-dialog.component';
import { ErrorResponse } from 'src/app/models/error.model';
import { ID } from 'src/app/models/ID.model';
import { ShortenedWarranty } from 'src/app/models/shortened-warranty.model';
import { Tenant } from 'src/app/models/tenant.model';
import { Warranty } from 'src/app/models/warranty.model';
import { GuarantiesService } from 'src/app/services/guaranties.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Owner } from 'src/app/models/owner.model';

import { ContratoLocacionService } from 'src/app/services/contract.location.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ContratoLocacionDTO, PersonaContratoDTO, PropiedadContratoDTO } from 'src/app/models/location-contract';
import { DocumentsService } from 'src/app/services/documents.service';

@Component({
    selector: 'app-new-contract',
    templateUrl: './new-contract-component.html',
    styleUrls: ['./new-contract-component.scss']
})
export class NewContractComponent implements OnInit {

    selectedWarranty?: ShortenedWarranty;
    warranty?: Warranty;
    contratoDTO: ContratoLocacionDTO;
    // Agregar estas propiedades al componente
    contratoGenerado: boolean = false;
    generandoContrato: boolean = false;
    contratoId?: number;
    documentdocx: string;
    documentpdf: string;

    // Opciones para selects
    tiposInmueble = [
        { value: 'casa', label: 'Casa' },
        { value: 'departamento', label: 'Departamento' }
    ];

    monedasPago = [
        { value: 'pesos', label: 'Pesos Argentinos' },
        { value: 'dolares', label: 'Dólares Americanos' }
    ];

    tiposAjuste = [
        { value: 'ninguno', label: 'Sin ajuste' },
        { value: 'si', label: 'Con ajuste' }
    ];

    tiposIndiceAjuste = [
        { value: 'IPC', label: 'IPC - Índice de Precios al Consumidor' },
        { value: 'ICA', label: 'ICA - Índice de Contratos de Alquiler' },
        { value: 'PORCENTAJE', label: 'Porcentaje fijo' }
    ];

    frecuenciasAjuste = [
        { value: 'mensual', label: 'Mensual' },
        { value: 'trimestral', label: 'Trimestral' },
        { value: 'semestral', label: 'Semestral' },
        { value: 'anual', label: 'Anual' }
    ];

    formasPago = [
        { value: 'EfectivoAlLocador', label: 'Efectivo al locador' },
        { value: 'EfectivoenInmobiliaria', label: 'Efectivo en inmobiliaria' },
        { value: 'TransferenciaCBU', label: 'Transferencia bancaria' },
        { value: 'DepositoBancario', label: 'Depósito bancario' }
    ];

    responsablesSellos = [
        { value: 'EL LOCADOR', label: 'El Locador' },
        { value: 'EL LOCATARIO', label: 'El Locatario' }
    ];

    constructor(
        private dialog: MatDialog,
        private guarantiesService: GuarantiesService,
        private contratoLocacionService: ContratoLocacionService,
        public utilsService: UtilsService,
        private documentsService: DocumentsService,
    ) {
        this.initializeDTO();
    }

    ngOnInit(): void {
        // La inicialización se hace en el constructor
    }

    initializeDTO(): void {
        this.contratoDTO = {
            fechaFirma: '',
            ciudadFirma: '',
            fechaInicioAlquiler: '',
            fechaFinAlquiler: '',
            plazoContrato: 0,
            propietarios: [],
            inquilinos: [],
            propiedad: {
                domicilio: '',
                calle: '',
                municipio: '',
                provincia: ''
            },
            alquiler: {
                monto: 0,
                texto: ''
            },
            tipoInmueble: 'departamento',
            monedaPago: 'pesos',
            tipoAjuste: 'ninguno',
            tipoIndiceAjuste: null,
            frecuenciaAjuste: 'trimestral',
            porcentajeAumento: null,
            formaDePago: 'EfectivoAlLocador',
            domicilioPagoInmobiliaria: null,
            nroCBULocador: null,
            aliasLocador: null,
            bancoLocador: null,
            nroCuentaBancoLocador: null,
            monedaDepositoGarantia: 'ARS',
            montoDepositoGarantia: 0.0,
            mesesDepositoGarantia: 1,
            expensasOrdinarias: false,
            fianzaGarantor: false,
            responsableSellos: 'EL LOCADOR',
            gastoInstrumentacionLocatario: '',
            gastoInstrumentacionLocador: '',
            // Nuevos campos de gastos de instrumentación
            gastoCertificacionEscribano: 'locatario',
            gastoCertificacionLocador: 'locador',
            gastoAntecedentesCrediticios: 'locatario',
            gastoInformesDominio: 'locatario',
            honorariosRedaccion: 'locatario',
        };
    }

    openModal(): void {
        const dialogRef = this.dialog.open(WarrantySelectorDialogComponent, {
            width: '80%',
            height: '80%',
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getWarrantyDetails(result.id).then(() => {
                    this.mapWarrantyToDTO();
                }).catch(error => {
                    console.error('Error al obtener la garantía:', error);
                    this.utilsService.alert('Error al obtener la garantía', error.error?.descripcion);
                });
            }
        });
    }

    getWarrantyDetails(id: ID): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.guarantiesService.getWarrantyById(id).subscribe({
                next: warranty => {
                    this.warranty = warranty;
                    resolve();
                },
                error: (error: ErrorResponse) => {
                    this.utilsService.alert('Error al obtener datos de la garantía', error.error?.descripcion);
                    reject(error);
                },
            });
        });
    }

    mapWarrantyToDTO(): void {
        if (!this.warranty) return;

        // Mapear fechas
        this.contratoDTO.fechaInicioAlquiler = this.warranty.contratos?.datos?.fechaInicioAlquiler || '';
        this.contratoDTO.fechaFinAlquiler = this.warranty.contratos?.datos?.fechaFinAlquiler || '';

        // Mapear propietarios
        this.contratoDTO.propietarios = this.warranty.propiedad.propietarios?.map(p => this.mapPersona(p)) || [];

        // Mapear inquilinos
        this.contratoDTO.inquilinos = this.warranty.inquilinos?.map(i => this.mapPersona(i)) || [];

        // Mapear propiedad
        this.contratoDTO.propiedad = this.mapPropiedad(this.warranty.propiedad);

        // Mapear alquiler
        this.contratoDTO.alquiler = {
            monto: this.warranty.cotizacion.alquiler || 0,
            texto: this.numberToWords(this.warranty.cotizacion.alquiler || 0)
        };

        // Calcular depósito por defecto (1 mes de alquiler)
        this.contratoDTO.montoDepositoGarantia = this.warranty.cotizacion.alquiler || 0;
        this.contratoDTO.fianzaGarantor = true;
    }

    mapPersona(persona: Tenant | Owner): PersonaContratoDTO {
        const esPersonaFisica = persona.tipoPersona === 'FISICA';

        return {
            fisica: esPersonaFisica,
            nombre: esPersonaFisica
                ? `${persona.personaFisica?.nombre || ''} ${persona.personaFisica?.apellido || ''}`
                : persona.personaJuridica?.razonSocial || '',
            documento: esPersonaFisica
                ? persona.personaFisica?.dni || ''
                : persona.personaJuridica?.cuit || '',
            cuit: esPersonaFisica
                ? persona.personaFisica?.cuit || ''
                : persona.personaJuridica?.cuit || '',
            email: persona.email || '',
            celular: esPersonaFisica
                ? this.buildCelularString(persona.personaFisica?.celular)
                : this.buildCelularString(persona.personaJuridica?.celular),
            domicilio: esPersonaFisica
                ? this.buildDomicilioString(persona.personaFisica?.direccion)
                : this.buildDomicilioString(persona.personaJuridica?.direccion),
            direccion: esPersonaFisica ? {
                localidad: persona.personaFisica?.direccion?.localidad?.descripcion || '',
                municipio: persona.personaFisica?.direccion?.localidad?.municipio?.descripcion || '',
                provincia: persona.personaFisica?.direccion?.localidad?.provincia?.descripcion || ''
            } : {
                localidad: persona.personaJuridica?.direccion?.localidad?.descripcion || '',
                municipio: persona.personaJuridica?.direccion?.localidad?.municipio?.descripcion || '',
                provincia: persona.personaJuridica?.direccion?.localidad?.provincia?.descripcion || ''
            },
            // Para personas jurídicas
            denominacionSocial: !esPersonaFisica ? persona.personaJuridica?.razonSocial : undefined,
            dniRepresentante: !esPersonaFisica ? persona.personaJuridica?.representante?.dni : undefined,
            cargo: !esPersonaFisica ? persona.personaJuridica?.representante?.cargo : undefined,
            telefono: !esPersonaFisica ? this.buildCelularString(persona.personaJuridica?.celular) : undefined
        };
    }

    // Método helper para construir el string del celular de forma segura
    private buildCelularString(celular: any): string {
        if (!celular) return '';

        const codigoArea = celular.codigoArea ? celular.codigoArea.toString() : '';
        const numero = celular.numero ? celular.numero.toString() : '';

        if (!codigoArea && !numero) return '';

        return `${codigoArea}${numero}`;
    }

    // También actualiza el método buildDomicilioString para ser más seguro
    buildDomicilioString(direccion: any): string {
        if (!direccion) return '';

        const parts = [
            direccion.calle || '',
            direccion.numero ? direccion.numero.toString() : '',
            direccion.piso ? `Piso ${direccion.piso}` : '',
            direccion.departamento ? `Depto ${direccion.departamento}` : ''
        ].filter(part => part && part.trim() !== '');

        return parts.join(', ');
    }

    mapPropiedad(propiedad: any): PropiedadContratoDTO {
        const direccion = propiedad.direccion;
        return {
            domicilio: this.buildDomicilioString(direccion),
            calle: `${direccion?.calle || ''} ${direccion?.numero || ''}`.trim(),
            municipio: direccion?.municipio || '',
            provincia: direccion?.provincia || '',
            unidadFuncional: direccion?.unidadFuncional || null,
            piso: direccion?.piso || null,
            departamento: direccion?.departamento || null
        };
    }


    // Event handlers para fechas
    onFechaFirmaChange(event: MatDatepickerInputEvent<Date>): void {
        const date = event.value;
        if (date) {
            this.contratoDTO.fechaFirma = date.toISOString().split('T')[0];
        }
    }

    onFechaInicioChange(event: MatDatepickerInputEvent<Date>): void {
        const date = event.value;
        if (date) {
            this.contratoDTO.fechaInicioAlquiler = date.toISOString().split('T')[0];
            this.updatePlazoContrato();
        }
    }

    onFechaFinChange(event: MatDatepickerInputEvent<Date>): void {
        const date = event.value;
        if (date) {
            this.contratoDTO.fechaFinAlquiler = date.toISOString().split('T')[0];
            this.updatePlazoContrato();
        }
    }
    /**
     * Actualiza el plazo del contrato basado en las fechas
     */
    updatePlazoContrato(): void {
        if (this.contratoDTO.fechaInicioAlquiler && this.contratoDTO.fechaFinAlquiler) {
            const startDate = new Date(this.contratoDTO.fechaInicioAlquiler);
            const endDate = new Date(this.contratoDTO.fechaFinAlquiler);

            this.contratoDTO.plazoContrato = this.calculateMonthsDifference(startDate, endDate);
        }
    }

    // Event handler para actualizar monto en texto
    onMontoAlquilerChange(): void {
        if (this.contratoDTO.alquiler) {
            this.contratoDTO.alquiler.texto = this.numberToWords(this.contratoDTO.alquiler.monto);
        }
    }

    // Event handler para ajustes
    onTipoAjusteChange(): void {
        if (this.contratoDTO.tipoAjuste === 'ninguno') {
            this.contratoDTO.tipoIndiceAjuste = null;
            this.contratoDTO.porcentajeAumento = null;
        }
    }

    onTipoIndiceChange(): void {
        if (this.contratoDTO.tipoIndiceAjuste !== 'PORCENTAJE') {
            this.contratoDTO.porcentajeAumento = null;
        }
    }

    generatePreview(): void {
        if (!this.isFormValid()) {
            this.utilsService.alert('Formulario incompleto', 'Por favor complete todos los campos requeridos');
            return;
        }
        this.buildGastosInstrumentacion();

        const guaranteeId = Number(this.warranty?.id) || 0;

        this.contratoLocacionService.generatePreview(guaranteeId, this.contratoDTO)
            .subscribe({
                next: (blob) => {
                    this.downloadFile(blob, `contract-preview.pdf`);
                },
                error: (error) => {
                    console.error('Error generating preview:', error);
                    this.utilsService.alert('Error', 'No se pudo generar la vista previa del contrato');
                }
            });
    }

    downloadFile(blob: Blob, filename: string): void {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    numberToWords(num: number): string {
        // Implementación básica - puedes usar una librería más robusta
        return `${num.toLocaleString('es-AR')} pesos`;
    }

    // Validaciones
    isFormValid(): boolean {
        return !!(
            this.contratoDTO.fechaFirma &&
            this.contratoDTO.ciudadFirma &&
            this.contratoDTO.fechaInicioAlquiler &&
            this.contratoDTO.fechaFinAlquiler &&
            this.contratoDTO.alquiler?.monto &&
            this.contratoDTO.propietarios?.length &&
            this.contratoDTO.inquilinos?.length &&
            this.isPaymentFormValid()
        );
    }

    isPaymentFormValid(): boolean {
        switch (this.contratoDTO.formaDePago) {
            case 'TransferenciaCBU':
                return !!(this.contratoDTO.nroCBULocador && this.contratoDTO.aliasLocador);
            case 'DepositoBancario':
                return !!(this.contratoDTO.bancoLocador && this.contratoDTO.nroCuentaBancoLocador);
            case 'EfectivoenInmobiliaria':
                return !!this.contratoDTO.domicilioPagoInmobiliaria;
            default:
                return true;
        }
    }

    getNombre(persona: Tenant | Owner): string {
        if (persona.tipoPersona === 'FISICA') {
            return `${persona.personaFisica?.nombre || ''} ${persona.personaFisica?.apellido || ''}`;
        }
        return persona.personaJuridica?.razonSocial || '';
    }

    getNombreInquilino(garantia: Warranty): string {
        let inquilino = garantia.inquilinos.find(i => i.id === garantia.idInquilinoPrincipal);
        if (inquilino?.tipoPersona === 'FISICA' && inquilino.personaFisica?.nombre)
            return inquilino.personaFisica.nombre + ' ' + inquilino.personaFisica.apellido;
        else if (inquilino?.tipoPersona === 'JURIDICA' && inquilino.personaJuridica?.razonSocial)
            return inquilino.personaJuridica.razonSocial;
        else
            return '';
    }

    // Getters para template
    get tieneAjuste(): boolean {
        return this.contratoDTO.tipoAjuste === 'si';
    }

    get requierePorcentaje(): boolean {
        return this.contratoDTO.tipoIndiceAjuste === 'PORCENTAJE';
    }

    get formaDePagoSeleccionada(): string {
        return this.contratoDTO.formaDePago || 'EfectivoAlLocador';
    }
    /**
 * Obtiene la etiqueta legible de la forma de pago
 */
    getFormaDePagoLabel(formaPago: string): string {
        const formas: { [key: string]: string } = {
            'EfectivoAlLocador': 'Efectivo al locador',
            'EfectivoenInmobiliaria': 'Efectivo en inmobiliaria',
            'TransferenciaCBU': 'Transferencia bancaria',
            'DepositoBancario': 'Depósito bancario'
        };
        return formas[formaPago] || formaPago;
    }

    /**
 * Confirma el contrato y actualiza el estado
 */
    confirmContract(): void {
        if (!this.isFormValid() || !this.warranty?.id) {
            this.utilsService.alert('Datos incompletos', 'Verifique que todos los campos estén completos y que haya seleccionado una garantía');
            return;
        }
        this.buildGastosInstrumentacion();

        this.generandoContrato = true;

        this.contratoLocacionService.confirmContract(Number(this.warranty.id), this.contratoDTO)
            .subscribe({
                next: (contratoCompleto: ContratoLocacionDTO) => {
                    this.generandoContrato = false;
                    this.contratoGenerado = true;
                    this.contratoDTO = contratoCompleto; // Asignar la respuesta completa                  
                },
                error: (error) => {
                    this.generandoContrato = false;
                    console.error('Error confirming contract:', error);
                    this.utilsService.alert('Error', 'No se pudo confirmar el contrato: ' + (error.error?.message || 'Error desconocido'));
                }
            });
    }
    /**
 * Construye las cadenas de gastos de instrumentación basado en las selecciones
 */
    private buildGastosInstrumentacion(): void {
        const gastosLocatario: string[] = [];
        const gastosLocador: string[] = [];

        // Impuesto de sellos
        if (this.contratoDTO.responsableSellos === 'EL LOCATARIO') {
            gastosLocatario.push('- Impuesto de sellos');
        } else if (this.contratoDTO.responsableSellos === 'EL LOCADOR') {
            gastosLocador.push('- Impuesto de sellos');
        }

        // Certificación ante escribano
        if (this.contratoDTO.gastoCertificacionEscribano === 'locatario') {
            gastosLocatario.push('- Gastos y honorarios de certificación de firmas ante Escribano Público. ');
        } else if (this.contratoDTO.gastoCertificacionEscribano === 'locador') {
            gastosLocador.push('- Gastos y honorarios de certificación de firmas ante Escribano Público. ');
        }

        // Certificación del locador
        if (this.contratoDTO.gastoCertificacionLocador === 'locatario') {
            gastosLocatario.push('- Gastos y honorarios de certificación de firma del Locador y su cónyuge. ');
        } else if (this.contratoDTO.gastoCertificacionLocador === 'locador') {
            gastosLocador.push('- Gastos y honorarios de certificación de firma del Locador y su cónyuge. ');
        }

        // Antecedentes crediticios
        if (this.contratoDTO.gastoAntecedentesCrediticios === 'locatario') {
            gastosLocatario.push('- Gastos de gestión de consulta de antecedentes crediticios. ');
        } else if (this.contratoDTO.gastoAntecedentesCrediticios === 'locador') {
            gastosLocador.push('- Gastos de gestión de consulta de antecedentes crediticios. ');
        }

        // Informes de dominio
        if (this.contratoDTO.gastoInformesDominio === 'locatario') {
            gastosLocatario.push('- Gastos de informes de dominio e informe de frecuencia sobre el inmueble. ');
        } else if (this.contratoDTO.gastoInformesDominio === 'locador') {
            gastosLocador.push('- Gastos de informes de dominio e informe de frecuencia sobre el inmueble. ');
        }

        // Honorarios de redacción
        if (this.contratoDTO.honorariosRedaccion === 'locatario') {
            gastosLocatario.push('- Honorarios por la redacción contractual de este contrato.');
        } else if (this.contratoDTO.honorariosRedaccion === 'locador') {
            gastosLocador.push('- Honorarios por la redacción contractual de este contrato.');
        }

        // Asignar las cadenas construidas
        this.contratoDTO.gastoInstrumentacionLocatario = gastosLocatario.length > 0
            ? `A cargo del LOCATARIO:\n${gastosLocatario.join('\n')}`
            : '';

        this.contratoDTO.gastoInstrumentacionLocador = gastosLocador.length > 0
            ? `A cargo del LOCADOR:\n${gastosLocador.join('\n')}`
            : '';
    }


    /**
     * Calcula la diferencia en meses entre dos fechas
    */
    calculateMonthsDifference(startDate: Date, endDate: Date): number {
        if (!startDate || !endDate) return 0;

        const yearDiff = endDate.getFullYear() - startDate.getFullYear();
        const monthDiff = endDate.getMonth() - startDate.getMonth();
        const dayDiff = endDate.getDate() - startDate.getDate();

        let totalMonths = yearDiff * 12 + monthDiff;

        // Si el día de fin es menor al día de inicio, restar un mes
        if (dayDiff < 0) {
            totalMonths--;
        }

        return totalMonths;
    }

    downloadDocument(documentId: ID) {
        this.documentsService.downloadContract(documentId).subscribe(({ blob }) => {
            this.utilsService.downloadBlobAsFile(blob, 'locacion-' + this.contratoDTO.contratoId.toString());
        }, (error: ErrorResponse) => this.utilsService.alert('Error al descargar archivo', error.error?.descripcion));
    }

    /**
     * Descarga el PDF del contrato
     */
    downloadPDF(): void {
        this.downloadDocument(this.contratoDTO.documentoPDFId);
    }

    /**
     * Descarga el DOCX del contrato
     */
    downloadDOCX(): void {
        this.downloadDocument(this.contratoDTO.documentoDOCXId);
    }
}